import { isCustomer as checkIsCustomer, isThirdParty as checkIsThirdParty } from "le-coffre-resources/dist/MemberTypes";
import type { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { decodeLeCoffreAccessTokenUserUid } from "@Front/Utils/accessTokenJwtClaimsHelpers";
import { resolveActiveAuthContextFromSession } from "@Front/Api/helpers/authTokenResolutionHelpers";
import { getLeCoffreNotaryAccessTokenCookie } from "@Front/Utils/lecoffreSessionCookieHelpers";

export function isExcludedNotaryOfficeBootstrapPersona(permissionContext: PermissionContextDto | null): boolean {
	const activeSessionContext = resolveActiveAuthContextFromSession();
	if (activeSessionContext === "customer" || activeSessionContext === "thirdparty") {
		return true;
	}
	const isThirdParty =
		checkIsThirdParty(permissionContext?.userType) || checkIsThirdParty(permissionContext?.globalRole);
	const isCustomer =
		checkIsCustomer(permissionContext?.userType) || checkIsCustomer(permissionContext?.globalRole);
	return isThirdParty || isCustomer;
}

export function resolveNotaryUserUidForOfficeLoad(permissionContext: PermissionContextDto | null): string | null {
	const fromContext =
		typeof permissionContext?.userId === "string" ? permissionContext.userId.trim() : "";
	if (fromContext) {
		return fromContext;
	}
	const notaryAccessToken = getLeCoffreNotaryAccessTokenCookie();
	return notaryAccessToken ? decodeLeCoffreAccessTokenUserUid(notaryAccessToken) : null;
}
